import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useCurrentCalculatorSegments } from '@/composables/useCurrentCalculatorSegments';

export function useCurrentSegment() {
  const { currentSegments } = useCurrentCalculatorSegments();

  const route = useRoute();

  const currentSegment = computed(() => {
    if (!currentSegments.value) return null;

    return currentSegments.value.find((segment) => segment.id === Number(route.params.segmentId));
  });

  const currentSegmentGroups = computed(() => {
    if (!currentSegment.value) return [];

    return currentSegment.value.view_groups;
  });

  const navigableSegmentGroups = computed(() => {
    if (!currentSegment.value) return [];

    return currentSegment.value.view_groups.filter((group) => {
      return group.views && group.views.length > 0;
    });
  });

  const currentSegmentGroupsViews = computed(() => {
    return currentSegmentGroups.value.find((group) => group.id === Number(route.params.groupId));
  });

  const currentSegmentViews = computed(() => {
    return currentSegmentGroups.value.flatMap((group) => group.views);
  });

  return {
    currentSegment,
    currentSegmentViews,
    currentSegmentGroupsViews,
    currentSegmentGroups,
    navigableSegmentGroups
  };
}
